import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

const ChatroomOnList = props => {
  const {
    chatroom,
    selectedChatroom,
    selectChatroom
  } = props;

  return (
    <li
      className={
        "list-group-item pointer-hand" +
        (chatroom.id == selectedChatroom.id ? " active" : "")
      }
      onClick={e => props.selectChatroom(chatroom)}
    >
      {chatroom.title}
      {props.chatroomHasUpdates(chatroom) &&
        <span className="dot"></span>
      }
      <div className="chatroom-sub-title">
        {chatroom.sub_title &&
          <div>{chatroom.sub_title}</div>
        }
      </div>
    </li>
  )
}

class ChatroomList extends React.Component {
  state = {
    message: "",
    loading: false
  };

  render() {
    const {
      chatrooms,
      selectedChatroom,
      selectChatroom
    } = this.props;

    return (
      <div>
        <ul className="shadowDepth1 list-group chatroom-rooms">
          {selectedChatroom && chatrooms.map((chatroom) =>
            <ChatroomOnList
              chatroom={chatroom}
              selectedChatroom={selectedChatroom}
              key={chatroom.id}
              selectChatroom={selectChatroom}
              chatroomHasUpdates={this.chatroomHasUpdates}
            />
          )}
        </ul>
      </div>
    )
  }

  chatroomHasUpdates = (chatroom) => {
    return this.props.unreadChatrooms.includes(chatroom.id);
  }
}

ChatroomList.propTypes = {
  chatrooms: PropTypes.array,
  selectedChatroom: PropTypes.object,
  selectChatroom: PropTypes.func
};

export default ChatroomList;
